// Production-safe logging utility

export const LOG_LEVELS = {
  ERROR: 0,
  WARN: 1,
  INFO: 2,
  DEBUG: 3
} as const;

type LogLevel = typeof LOG_LEVELS[keyof typeof LOG_LEVELS];

const currentLogLevel: LogLevel = import.meta.env.DEV ? LOG_LEVELS.DEBUG : LOG_LEVELS.ERROR;

const shouldLog = (level: LogLevel): boolean => {
  return level <= currentLogLevel;
};

export const logger = {
  error: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.ERROR)) {
      console.error(`[ERROR] ${message}`, ...args);
    }
  },
  
  warn: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.WARN)) {
      console.warn(`[WARN] ${message}`, ...args);
    }
  },
  
  info: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.INFO)) {
      console.info(`[INFO] ${message}`, ...args);
    }
  },
  
  debug: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.DEBUG)) {
      console.log(`[DEBUG] ${message}`, ...args);
    }
  },

  // Specialized logging methods
  auth: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.INFO)) {
      console.info(`[AUTH] ${message}`, ...args);
    }
  },

  session: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.DEBUG)) {
      console.log(`[SESSION] ${message}`, ...args);
    }
  },

  audio: (message: string, ...args: unknown[]) => {
    if (shouldLog(LOG_LEVELS.DEBUG)) {
      console.log(`[AUDIO] ${message}`, ...args);
    }
  }
};